export const PLACES_SUCCESS = 'PLACES_SUCCESS';
export const PLACE_SUCCESS = 'PLACE_SUCCESS';
export const FLIGHTS_SUCCESS = 'FLIGHTS_SUCCESS';
export const TRIP_SUCCESS = 'TRIP_SUCCESS';
export const TYPE_DATES = 'TYPE_DATES';
export const SET_FLIGHTS = 'SET_FLIGHTS';
export const UPDATE_FLIGHT = 'UPDATE_FLIGHT'
